<template>
  <div class="container content-block" v-if="fetchingQuest">
    <div class="row mt-3 mb-3">
      <div class="col text-center">
        <div class="alert alert-info" role="alert">
          Activiteit ophalen.
        </div>
        <div class="d-flex justify-content-center">
          <div class="spinner-border" role="status">
            <span class="sr-only">Laden...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="quest == null">
    <NotFound></NotFound>
  </div>
  <div class="container" v-else>
    <div class="row">
      <!--      <router-link to="/activities"><i class="fas fa-chevron-left"></i> Terug</router-link>-->
            <ButtonBack></ButtonBack>
    </div>
    <div class="row content mt-3 mb-3">
      <div class="col-lg-4">
        <QuestSummaryPanel :quest="quest" :previous-activities="[]"
                           @plan-quest="planActivityClicked"></QuestSummaryPanel>
      </div>
      <div class="col-lg-8 col-12">
        <QuestDetailPanel :quest="quest"></QuestDetailPanel>
      </div>
    </div>
  </div>
</template>

<script>
import QuestSummaryPanel from "@/components/Quests/QuestSummaryPanel";
import QuestDetailPanel from "@/components/Quests/QuestDetailPanel";
import { QuestApi } from "sandpiper_api";
import log from "@/utils/logger";
import NotFound from "@/components/Common/NotFound";
import ButtonBack from "@/components/UI/ButtonBack";

export default {
  name: "Activity",
  components: { QuestSummaryPanel, QuestDetailPanel, NotFound, ButtonBack },
  inject: [ "doApiRequest" ],
  data()
  {
    return {
      fetchingQuest: false,
      questId: null,
      quest: null,
      plannedActivities: []
    }
  },
  methods: {
    planActivityClicked()
    {
      this.$router.push({ name: "plan-activity", query: { questId: this.questId } });
    },
    fetchPathParams()
    {
      this.questId = this.$route.params.id;
    },
    async fetchQuest()
    {
      try
      {
        this.fetchingQuest = true;
        const response = await this.doApiRequest(() => new QuestApi().getQuest(this.questId));

        log.info("Fetch quest response: %o", response);
        this.quest = response;
      }
      catch (e)
      {
        this.quest = null;
        // TODO - handle exception, return to quest list?
        // await this.$router.push({name: 'quests'});
      }
      finally
      {
        this.fetchingQuest = false;
      }
    }
  },
  created()
  {
    this.fetchPathParams();
    this.fetchQuest();
  }
}
</script>

<style lang="scss" scoped>
.content
{
  margin: 1rem 0;

  @media screen and (max-width: $large)
  {
    margin: 0 0;

    .content-col
    {
      margin-left: 0;
      margin-right: 0;
    }
  }
}
</style>